/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type FormSubmitEmbedEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const formSubmitEmbedEntrypoint: EntryPoint<FormSubmitEmbedEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<FormSubmitEmbedEntrypointComponent>(
			/* webpackChunkName: "async-business-form-submit-embed-entrypoint" */ './JiraBusinessFormEmbedAppMemo.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
